import { createRestAPI } from '@dabble/rest-client';

export const PUBLIC_PATCHES_KEY = import.meta.env.PUBLIC_PATCHES_KEY;
export const PUBLIC_PATCHES_URL = import.meta.env.PUBLIC_PATCHES_URL;
export const PUBLIC_ACCOUNTS_URL = import.meta.env.PUBLIC_ACCOUNTS_URL;
export const PUBLIC_REST_URL = import.meta.env.PUBLIC_REST_URL;
export const PUBLIC_SERVER_KEY = import.meta.env.PUBLIC_SERVER_KEY;
export const PUBLIC_APP_URL = import.meta.env.PUBLIC_APP_URL || 'https://app.dabblewriter.com';

export { RestError } from '@dabble/rest-client';

// Dabble REST API. `.send()` returns the parsed JSON body and throws RestError
// on non-2xx; object bodies are JSON-encoded automatically.
export const rest = createRestAPI(PUBLIC_REST_URL);
rest.hook(req => {
  if (PUBLIC_SERVER_KEY) req.header('Authorization', `Bearer ${PUBLIC_SERVER_KEY}`);
  req.credentials('include');
});

// Patches (pup) REST API — document reads, search, admin endpoints.
export const patchesRest = createRestAPI(PUBLIC_PATCHES_URL, { Accept: 'application/json, text/event-stream' });
patchesRest.hook(req => {
  if (PUBLIC_PATCHES_KEY) req.header('Authorization', `Bearer ${PUBLIC_PATCHES_KEY}`);
  req.credentials('include');
});

/**
 * Tolerant read for GET paths. `.send()` throws RestError on any non-2xx, but
 * the loaders this replaced (vueuse `createFetch`) resolved with null and let
 * the view degrade to its empty state. Use this for reads where "no data" is a
 * normal outcome (missing invoice, new user, expired session) so a non-2xx
 * renders blank instead of throwing an uncaught rejection out of a loader.
 * Writes keep their try/catch so the user still sees failures.
 */
export async function readOrNull<T>(send: Promise<T>): Promise<T | null> {
  try {
    return await send;
  } catch (err) {
    console.warn('Read failed, degrading to empty:', err);
    return null;
  }
}
